import { Box, createStyles, getStylesRef, Group } from '@mantine/core';
import { buttonHoverTransition } from '@repo/theme/primitives';
import type { ReactNode } from 'react';

const useStyles = createStyles((theme) => ({
	wrapper: {
		display: 'flex',
		flexDirection: 'column',
		justifyContent: 'flex-end',

		[`&:not([data-force-show]) .${getStylesRef('toolbar')}`]: {
			opacity: 0,
		},

		[`&:hover .${getStylesRef('toolbar')}`]: {
			opacity: 1,
		},
	},
	toolbar: {
		ref: getStylesRef('toolbar'),
		paddingTop: theme.spacing.xs,
		paddingBottom: theme.spacing.sm,
		...buttonHoverTransition('opacity'),
	},
}));

export function MessageToolbar({
	children,
	className,
}: {
	children: ReactNode;
	className?: string;
}) {
	const { classes, cx } = useStyles();
	return (
		<Group spacing={0} className={cx(classes.toolbar, className)}>
			{children}
		</Group>
	);
}

function MessageToolbarWrapper({
	children,
	className,
	forceShow,
}: {
	children: ReactNode;
	forceShow?: boolean;
	className?: string;
}) {
	const { classes, cx } = useStyles();
	return (
		<Box
			data-force-show={forceShow ? 'true' : undefined}
			className={cx(classes.wrapper, className)}
		>
			{children}
		</Box>
	);
}

MessageToolbar.Wrapper = MessageToolbarWrapper;
